import React, { useState } from 'react'
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    IconButton,
    Box,
    Pagination,
    Skeleton,
    TextField,
    Stack,
    Divider,
} from '@mui/material'
import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import SearchIcon from '@mui/icons-material/Search'
import CloseIcon from '@mui/icons-material/Close'

export const CustomTableSkeleton = ({
    columns,
    backgroundColor,
}) => {
    return (
        <Box sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'space-between',
            justifyContent: 'space-between',
            overflowY: 'auto',
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': {
                display: 'none',
            },
        }}>
            <Stack sx={{
                gap: '16px',
            }}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    mb: '8px',
                    mr: '28px',
                }}>
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        
                        height: '100%',
                        // backgroundColor: '#1F477D',
                        // borderRadius: '8px',
                    }}>
                        <SearchIcon sx={{ mr: '10px', color: '#6B7280' }} />
                    </Box>
                    <TextField
                        fullWidth
                        size="small"
                        placeholder="Search..."
                        value={''}
                        onChange={() => {}}
                        slotProps={{
                            input: {
                                inputProps: {
                                    sx: {
                                        fontSize: '14px',
                                        fontWeight: 400,
                                        color: '#6B7280',
                                        '&::placeholder': {
                                            color: '#6B7280',
                                        },  
                                        px: '0px',
                                    }
                                },

                                // startAdornment: (
                                //     <SearchIcon sx={{ mr: '10px', color: '#6B7280' }} />
                                // ),
                            },
                        }}  
                        sx={{
                            '& .MuiInputBase-root': {
                                backgroundColor: '#F9FAFB',
                                pr: '0px',
                                border: 'none',
                                borderBottom: '1px solid #E5E7EB',
                                borderRadius: 0,
                                '&:hover': {
                                    borderBottom: '1px solid #E5E7EB',
                                },
                                '&.Mui-focused': {
                                    borderBottom: '1px solid #E5E7EB',
                                },
                                '& fieldset': {
                                    border: 'none',
                                },
                                '&:hover fieldset': {
                                    border: 'none',
                                },
                                '&.Mui-focused fieldset': {
                                    border: 'none',
                                },
                            },
                        }}
                    />
                </Box>
                <TableContainer sx={{ 
                    backgroundColor: backgroundColor, 
                    scrollbarWidth: 'none', 
                    '&::-webkit-scrollbar': { 
                        display: 'none' 
                    }, 
                    overflowY: 'auto' }}>
                    <Table sx={{ minWidth: 650 }}>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: backgroundColor }}>
                                {columns.map((column, index) => (
                                    <TableCell
                                        key={index}
                                        sx={{
                                            border: 'none',
                                            borderBottom: '1px solid #E5E7EB',
                                            padding: index === 0 ? '12px 24px 16px 0px' : '12px 16px 16px 16px',
                                            width: column.width || 'auto',
                                            minWidth: column.minWidth || 'auto',
                                        }}
                                    >
                                        <Skeleton variant='text'/>
                                    </TableCell>
                                ))}
                                <TableCell
                                    sx={{
                                        border: 'none',
                                        borderBottom: '1px solid #E5E7EB',
                                        padding: '12px 16px',
                                        width: '50px',
                                    }}
                                />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Array.from({ length: 5 }).map((_, rowIndex) => (
                                <TableRow
                                    key={rowIndex}
                                    sx={{
                                        '&:last-child td': {
                                            borderBottom: '1px solid #E5E7EB',
                                        },
                                    }}
                                >
                                    {columns.map((column, colIndex) => (
                                        <TableCell
                                            key={colIndex}
                                            onClick={(e) => {
                                                // e.stopPropagation()
                                                // onRowInteraction && onRowInteraction()
                                            }}
                                            sx={{
                                                border: 'none',
                                                borderBottom: '1px solid #E5E7EB',
                                                padding: colIndex === 0 ? '16px 24px 16px 0px' : '16px',
                                            }}
                                        >
                                            <Skeleton variant='text'/>
                                        </TableCell>
                                    ))}
                                    <TableCell
                                        sx={{
                                            border: 'none',
                                            borderBottom: '1px solid #E5E7EB',
                                            padding: '16px 24px',
                                            textAlign: 'right',
                                        }}
                                    >
                                        <IconButton
                                            size="small"
                                            sx={{
                                                padding: '0px',
                                            }}
                                        >
                                            <MoreHorizIcon 
                                                fontSize="small" 
                                                sx={{ color: '#9CA3AF' }} 
                                            />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                
                {/* Pagination */}
                <Box 
                    display="flex" 
                    justifyContent="space-between" 
                    alignItems="center" 
                    sx={{ 
                        p: '12px 0px',
                        mb: '50px'
                    }}
                >
                    <Skeleton variant='rectangular' width={'150px'} height={'20px'} />

                    <Box sx={{
                        display: 'flex',
                        gap: '3px'
                    }}>
                        <Skeleton variant='rectangular' width={'32px'} height={'32px'} />
                        <Skeleton variant='rectangular' width={'32px'} height={'32px'} />
                        <Skeleton variant='rectangular' width={'32px'} height={'32px'} />
                    </Box>
                </Box>
            </Stack>
        </Box>
    )
}

const CustomTable = ({
    columns,
    data,
    onRowClick,
    onMenuClick,
    backgroundColor,
    searchBar = true,
    menuColumn = true,
    pagination = true,
    highlightedRowId = null,
    onRowInteraction = null,
}) => {
    const [currentPage, setCurrentPage] = useState(1)
    const [searchQuery, setSearchQuery] = useState('')
    
    // Debug logging
    console.log('CustomTable received props:', { highlightedRowId, onRowInteraction: !!onRowInteraction })

    const rowsPerPage = pagination ? 10 : data.length
    
    const filteredData = React.useMemo(() => {
        if (searchQuery === '') {
            return data
        }
        
        return data.filter((row) => {
            return row[columns[0].field].toLowerCase().includes(searchQuery.toLowerCase())
        })
        
    }, [data, searchQuery])
    
    const startIndex = (currentPage - 1) * rowsPerPage
    const endIndex = startIndex + rowsPerPage
    
    const paginatedData = filteredData.slice(startIndex, endIndex)
    
    
    const handlePageChange = (event, newPage) => {
        setCurrentPage(newPage)
    }
    
    const totalPages = Math.ceil(filteredData.length / rowsPerPage)
    
    const showingText = `Showing ${currentPage} of ${totalPages} pages`
    
    return (
        <Box sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'space-between',
            justifyContent: 'space-between',
        }}>
            <Stack sx={{
                gap: '16px',
            }}>
                {searchBar && (
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        mb: '8px',
                        mr: '28px',
                    }}>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            
                            height: '100%',
                            // backgroundColor: '#1F477D',
                            // borderRadius: '8px',
                        }}>
                            <SearchIcon sx={{ mr: '10px', color: '#6B7280' }} />
                        </Box>
                        <TextField
                            fullWidth
                            size="small"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={(e) =>
                                setSearchQuery(e.target.value)
                            }
                            slotProps={{
                                input: {
                                    inputProps: {
                                        sx: {
                                            fontSize: '14px',
                                            fontWeight: 400,
                                            color: '#6B7280',
                                            '&::placeholder': {
                                                color: '#6B7280',
                                            },  
                                            px: '0px',
                                        }
                                    },

                                    // startAdornment: (
                                    //     <SearchIcon sx={{ mr: '10px', color: '#6B7280' }} />
                                    // ),
                                    
                                    endAdornment: (
                                        searchQuery !== '' ? (
                                            <IconButton onClick={() => setSearchQuery('')} sx={{
                                                mr: '10px',
                                                color: '#6B7280',
                                            }}>
                                                <CloseIcon sx={{ fontSize: '18px' }} />
                                            </IconButton>
                                        ) : null
                                    ),
                                },
                            }}  
                            sx={{
                                '& .MuiInputBase-root': {
                                    backgroundColor: '#F9FAFB',
                                    // px: '0px',
                                    border: 'none',
                                    borderBottom: '1px solid #E5E7EB',
                                    borderRadius: 0,
                                    '&:hover': {
                                        borderBottom: '1px solid #E5E7EB',
                                    },
                                    '&.Mui-focused': {
                                        borderBottom: '1px solid #E5E7EB',
                                    },
                                    '& fieldset': {
                                        border: 'none',
                                    },
                                    '&:hover fieldset': {
                                        border: 'none',
                                    },
                                    '&.Mui-focused fieldset': {
                                        border: 'none',
                                    },
                                },
                            }}
                        />
                        
                    </Box>
                )}
                <TableContainer sx={{ 
                    backgroundColor: backgroundColor,
                    scrollbarWidth: 'none', 
                    '&::-webkit-scrollbar': { 
                        display: 'none' 
                    },
                }}>
                    <Table sx={{ 
                        minWidth: 650,
                    }}>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: backgroundColor }}>
                                {columns.map((column, index) => (
                                    <TableCell
                                        key={index}
                                        sx={{
                                            border: 'none',
                                            borderBottom: '1px solid #E5E7EB',
                                            padding: index === 0 ? '12px 24px 16px 0px' : '12px 16px 16px 16px',
                                            width: column.width || 'auto',
                                            minWidth: column.minWidth || 'auto',
                                        }}
                                    >
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontWeight: 500,
                                                fontSize: '14px',
                                                color: '#6B7280',
                                            }}
                                        >
                                            {column.header}
                                        </Typography>
                                    </TableCell>
                                ))}
                                {menuColumn && (
                                    <TableCell
                                        sx={{
                                            border: 'none',
                                            borderBottom: '1px solid #E5E7EB',
                                            padding: '12px 16px',
                                            width: '50px',
                                        }}
                                    />
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {paginatedData.map((row, rowIndex) => (
                                <TableRow
                                    key={rowIndex}
                                    data-row-id={row.id}
                                    sx={{
                                        cursor: 'pointer',
                                        backgroundColor: row.id === highlightedRowId ? '#EEF2FF' : 'transparent',
                                        transition: 'background-color 0.3s ease',
                                        '&:last-child td': {
                                            borderBottom: '1px solid #E5E7EB',
                                        },
                                        '&:hover': {
                                            backgroundColor: '#F9FAFB',
                                        },
                                    }}
                                    onClick={() => {
                                        onRowInteraction && onRowInteraction()
                                        onRowClick && onRowClick(row)
                                    }}
                                    onMouseEnter={() => onRowInteraction && onRowInteraction()}
                                >
                                    {columns.map((column, colIndex) => (
                                        <TableCell
                                            key={colIndex}
                                            sx={{
                                                border: 'none',
                                                borderBottom: '1px solid #E5E7EB',
                                                padding: colIndex === 0 ? '16px 24px 16px 0px' : '16px',
                                            }}
                                        >
                                            {column.render ? (
                                                column.render(row[column.field], row)
                                            ) : (
                                                <Typography
                                                    variant="body2"
                                                    sx={{
                                                        fontSize: '14px',
                                                        color: '#374151',
                                                        fontWeight: 400,
                                                        lineHeight: '20px',
                                                        // fontStyle: 'normal'
                                                    }}
                                                >
                                                    {row[column.field]}
                                                </Typography>
                                            )}
                                        </TableCell>
                                    ))}
                                    {menuColumn && (
                                        <TableCell
                                            sx={{
                                                border: 'none',
                                                borderBottom: '1px solid #E5E7EB',
                                                padding: '16px 24px',
                                                textAlign: 'right',
                                            }}
                                        >
                                            <IconButton
                                                size="small"
                                                onClick={(e) => {
                                                    e.stopPropagation()
                                                    onMenuClick && onMenuClick(e, row)
                                                }}
                                                sx={{
                                                    padding: '0px',
                                                }}
                                            >
                                                <MoreHorizIcon 
                                                    fontSize="small" 
                                                    sx={{ color: '#9CA3AF' }} 
                                                />
                                            </IconButton>
                                        </TableCell>
                                    )}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                
                {/* Pagination */}
                {pagination && (
                    <Box 
                        display="flex" 
                        justifyContent="space-between" 
                        alignItems="center" 
                        sx={{ 
                            p: '12px 0px',
                            mb: '50px'
                        }}
                    >
                        <Typography 
                            variant="body2" 
                            sx={{ 
                                color: '#374151',
                                fontSize: '14px'
                            }}
                        >
                            {showingText}
                        </Typography>
                        
                        <Pagination
                            count={totalPages}
                            page={currentPage}
                            onChange={handlePageChange}
                            variant="outlined"
                            shape="rounded"
                            sx={{
                                '& .MuiPaginationItem-root': {
                                    border: '1px solid #D1D5DB',
                                    backgroundColor: '#FFFFFF',
                                    color: '#6B7280',
                                    fontSize: '14px',
                                    '&:hover': {
                                        backgroundColor: '#F9FAFB',
                                    },
                                    '&.Mui-selected': {
                                        border: '1px solid #4338CA',
                                        backgroundColor: '#1F477D',
                                        color: 'white',
                                        '&:hover': {
                                            backgroundColor: '#1A3F6B',
                                        },
                                    },
                                },
                            }}
                        />
                    </Box>
                )}
            </Stack>
        </Box>
    )
}

export default CustomTable 